export const quickList = [
  {
    id: 0,
    text: "ID_QUICK_CHAT_HELLO",
  },
  {
    id: 1,
    text: "ID_QUICK_CHAT_COOL",
  },
  {
    id: 2,
    text: "ID_QUICK_CHAT_HAHA",
  },
  {
    id: 3,
    text: "ID_QUICK_CHAT_GO_GAME",
  },
  {
    id: 4,
    text: "ID_QUICK_CHAT_LATER",
  },
  {
    id: 5,
    text: "ID_QUICK_CHAT_HI",
  },
  {
    id: 7,
    text: "ID_QUICK_CHAT_WAIT",
  },
  {
    id: 9,
    text: "ID_QUICK_CHAT_NICE_TO_MEET_YOU",
  },
  {
    id: 10,
    text: "ID_QUICK_CHAT_LETS_GO",
  },
  {
    id: 12,
    text: "ID_QUICK_CHAT_TAKE_A_SELFIE",
  },
];
